import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Paging, { ToPage, GetParams } from "@component/UI/Paging";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { code } = useParams();

    const { site, iam } = useContext(AppContext);
    const [isLoading, setIsLoading] = useState(true);
    const [noticeList, setNoticeList] = useState([]);
    const [list, setList] = useState([]);
    const [paging, setPaging] = useState(null);
    const [searchInfo, setSearchInfo] = useState({
        keyword: null,
        page: 1,
    });

    const getNavigation = () => {
        switch (code) {
            case "notice":
                return site?.naviBbsNotice;
            case "pds":
                return site?.naviBbsPds;
        }
    };

    const getTitle = () => {
        switch (code) {
            case "notice":
                return "Notice";
            case "pds":
                return "Download Center";
        }
    };

    const loadList = (data) => {
        _API.get({ path: "/site/bbs", data: { ...data, code } })
            .then((res) => {
                const { list, paging, noticeList } = res.data;
                setNoticeList(noticeList);
                setList(list);
                setPaging(paging);
                setIsLoading(false);
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    const onKeyDown = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };

    const movePage = (page) => {
        ToPage(location, navigate, { ...searchInfo, page });
    };

    const onSearch = (key, value) => {
        ToPage(location, navigate, { ...searchInfo, page: 1 });
    };

    useEffect(() => {
        if (code) {
            setIsLoading(true);
            const params = GetParams(location);
            if (params) {
                setSearchInfo(params);
                loadList(params);
            } else {
                setSearchInfo({
                    keyword: null,
                    page: 1,
                });
                loadList({
                    keyword: null,
                    page: 1,
                });
            }
        }

        return () => {
            setNoticeList([]);
            setList([]);
            setPaging(null);
        };
    }, [location, code]);

    let virtualNo = paging ? paging.virtualRecordNo : -1;

    return (
        <Fragment>
            {isLoading && <Loading />}
            <div className="contents">
                {getNavigation() && parse(getNavigation())}

                <div className="right">
                    <div className="contentsTop">
                        <h3>{getTitle()}</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>{getTitle()}</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="clear_float">
                            <div className="box_search">
                                <input
                                    type="text"
                                    name="keyword"
                                    placeholder="Keyword"
                                    value={searchInfo?.keyword}
                                    onChange={(e) => setSearchInfo({ ...searchInfo, keyword: e.target.value })}
                                    onKeyDown={onKeyDown}
                                />
                                <button className="btn1 btn_blue1" onClick={onSearch}>
                                    Search
                                </button>
                            </div>
                            <p className="board_count">Total : {paging?.totalSize || 0}</p>
                        </div>

                        <table className="tbl tbl_list m_tbl_notice">
                            <thead>
                                <tr>
                                    <th width="7%">No</th>
                                    <th>Subject</th>
                                    <th width="4%">Files</th>
                                    <th width="8%">Writer</th>
                                    <th width="8%">Hits</th>
                                    <th width="10%">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {noticeList?.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            <strong className="ico_notice">Notice</strong>
                                        </td>
                                        <td className="tit">
                                            <a href={`/bbs/${item.code}/${item.idx}`} className="ellipsis">
                                                {item.title}
                                            </a>
                                        </td>
                                        <td>
                                            {item?.fileList?.map((file, fIndex) => (
                                                <a href={file.signedUrl} target="_blank" key={fIndex}>
                                                    <img src="/assets/images/down.png" alt={file.name} />
                                                </a>
                                            ))}
                                        </td>
                                        <td>{item.writerName}</td>
                                        <td>{_U.addComma(item.hit)}</td>
                                        <td>{moment(item.regDate).format("YYYY-MM-DD")}</td>
                                    </tr>
                                ))}
                                {list?.length === 0 && (
                                    <tr>
                                        <td className="nodata" colspan="6">
                                            No data
                                        </td>
                                    </tr>
                                )}
                                {list?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{virtualNo--}</td>
                                        <td className="tit">
                                            <a href={`/bbs/${item.code}/${item.idx}`} className="ellipsis">
                                                {item.title}
                                            </a>
                                        </td>
                                        <td>
                                            {item?.fileList?.map((file, fIndex) => (
                                                <a href={file.signedUrl} target="_blank" key={fIndex}>
                                                    <img src="/assets/images/down.png" alt={file.name} />
                                                </a>
                                            ))}
                                        </td>
                                        <td>{item.writerName}</td>
                                        <td>{_U.addComma(item.hit)}</td>
                                        <td>{moment(item.regDate).format("YYYY-MM-DD")}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {paging && <Paging paging={paging} pageCallback={movePage} type="FRONT" />}
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
